let messaages_ja = {
	Salutation: {
		required: '挨拶文を選択してください.',
	},
	FirstName: {
		required: 'お名前(名)を入力してください。',
	},
	LastName: {
		required: '姓を入力してください。',
	},
	Email: {
		required: 'メールアドレスを入力してください。',
		email: '有効なメールアドレスを入力してください。',
	},
	Country: {
		required: '国を選択してください。',
	},
	Postcode: {
		required: '郵便番号を選択してください。',
	},
	Password: {
		required: 'パスワードを入力してください。',
	},
	ConfirmPassword: {
		required: '確認のためパスワードを入力してください。',
		equalTo: 'パスワードが一致していることを確認してください。',
	},
	TermsAndConditions: {
		required: '利用規約に同意してください。',
	}
};

export function messages_ja() {
	return messaages_ja;
}
